import { createSelector } from '@reduxjs/toolkit';
import { IState } from 'core';
import { BetType, IBets, IBetState } from './types';
import { getSummaryBet, confirmedBetsToObj } from './utils';

export const betRootSelector = (state: IState): IBetState => state.betReducer;

export const placedBetSelector = createSelector(
  betRootSelector,
  (state: IBetState): IBets => state.bets.placed,
);

export const confirmedBetSelector = createSelector(
  betRootSelector,
  (state: IBetState): BetType => confirmedBetsToObj(state.bets.confirmed),
);

export const summaryBetSelector = createSelector(
  betRootSelector,
  (state: IBetState): BetType =>
    getSummaryBet([state.bets.placed.present, confirmedBetsToObj(state.bets.confirmed)]),
);

export const isEmptySlotsSelector = createSelector(
  summaryBetSelector,
  (summaryBets: BetType): boolean =>
    Object.values(summaryBets).every((slotValue) => slotValue === 0),
);
